<template>
  <div>
    <p v-translate>You are about to begin processing this submission.</p>
    <p v-translate>In case changes are necessary, another version will need to be submitted.</p>
    <p v-translate>Press OK to continue.</p>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  }
}
</script>

